import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../_reducers';

//Custon middlewares
import { apiCallStackDiscardation } from '../Middleware';

const loggerMiddleware = createLogger();

export const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
        apiCallStackDiscardation
    )
);


// WEBPACK FOOTER //
// ./src/_helpers/store.js